let isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// categorize the screen size as either small, medium, or large, represented as 1,2,3, respectively
let screenCategory = () => {
    let mapping = {
        1: size => size <= 700,
        2: size => size > 700 && size <= 1200,
        3: size => size > 1200
    };

    let size = window.innerWidth;

    for (let mkey in mapping) {
        let mkeyFits = mapping[mkey](size);

        if (mapping.hasOwnProperty(mkey) && mkeyFits) {
            return mkey;
        }
    }
};


export { isMobile, screenCategory };


// WEBPACK FOOTER //
// ./assets/js/app/lib/utils.js